<template>
    <div class="formCom">
        <div class="form" v-click-outside="closeModal">
            <button class="close" @click="closeModal">
            <CloseIcone></CloseIcone>
            </button>
            <div class="name">
               Add Holiday
            </div>
            <div class="input-wrap">
                <input
                    type="text"
                    class="input"
                    v-validate="'required|max:50'"
                    placeholder="Name"
                    name="name"
                    maxlength="50"
                    v-model="name"
                />
                <span class="validate-error" v-if="errors.has('name')">
                    {{ errors.first("name") }}
                </span>
            </div>
            <div class="input-wrap">
                <select
                class="input select"
                v-model="year"
                name="year"
                v-validate="'required'"
              >
                <option v-for="currentDate in currentDates" v-bind:key="currentDate.value" v-bind:value="currentDate.value">{{currentDate.label}}</option>
              </select>
                <span class="validate-error" v-if="errors.has('year')">
                    {{ errors.first("year") }}
                </span>
            </div>
            <div class="input-wrap">
              <div @click="showError" class="datepickerWrapDiv">
                <Datepicker
                    :disabledDates="{ to: new Date() }"
                    :format="formatDate"
                    placeholder="Select Date"
                    v-model="date"
                    name="date"
                    v-validate="'required'"
                    :class="{ datepickerWrap: true }"
                    :input-class="{datepickerInput: true, error: dateError}"
                ></Datepicker>
                <span class="validate-error" v-if="errors.has('date')">
                    {{ errors.first("date") }}
                </span>
               </div>
            </div>
            <div  class="input-wrap">
                <button
                class="btn"
                @click.prevent="$validator.validateAll()"
                @click="addKit"
                >
                Save
                </button>
            </div>
        </div>
    </div>
  </template>
  
  <script>
  import moment from "moment";
  import { mapActions } from "vuex";
  import { mapGetters } from "vuex";
  import { mapMutations } from "vuex";
  import CloseIcone from "../../images/shared/cancel";
  import Datepicker from "vuejs-datepicker";
  import axios from "axios";
  
  export default {
    name: "AddHoliday",
    data() {
      return {
        name: null,
        year:null,
        date: null,
        dateError: false,
        currentDates: []
      };
    },
    components: {
      CloseIcone,
      Datepicker
    },
    methods: {
      ...mapActions(["addFederalHolidays"]),
      ...mapMutations(["clearServerValidationErrors"]),
      addKit() {
        // if (this.errors.any() || !this.isComplete) {
        //   return;
        // }
        const data = {
          name: this.name,
          year: this.year,
          holiday_at: this.date
        };
        this.addFederalHolidays(data).then(res => {
          this.errors.clear();
          this.clearServerValidationErrors();
          this.closeModal();
        });
      },
      closeModal() {
        this.errors.clear();
        this.clearServerValidationErrors();
        this.$emit("closeModal", false);
      },
      formatDate(date) {
        return moment(date).format("MMMM D, YYYY");
      },
      showError() {
        this.date === null
          ? (this.dateError = true)
          : (this.dateError = false);
      },
    },
    computed: {
      ...mapGetters(["serverValidation"])
    },
    watch: {
      serverValidation(error) {
        error.forEach(item => {
          this.$validator.errors.add({ field: item.field, msg: item.message });
        });
      }
    },
    mounted(){
      this.currentDates.push({'value': null, 'label': 'Select Years'},{'value': new Date().getFullYear(), 'label': new Date().getFullYear()},{'value': new Date().getFullYear()+1, 'label': new Date().getFullYear()+1});
    }
  };
  </script>
  
  <style scoped>
  .close {
    position: absolute;
    right: 15px;
    top: 15px;
    border: 1px solid transparent;
    cursor: pointer;
    width: 15px;
    height: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    background-color: transparent;
  }
  .formCom {
    background-color: rgba(219, 230, 241, 0.5);
    position: fixed;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    left: 0;
    top: 0;
    z-index: 99;
  }
  .input.invalid {
    border: 1px solid red;
  }
  .form {
    padding: 25px;
    background-color: #fff;
    max-width: 397px;
    width: 100%;
    position: relative;
    z-index: 1;
  }
  .input-wrap {
    width: 100%;
    margin: 0 0 30px 0;
  }
  .input {
    padding: 17px 20px;
    color: #373737;
    width: 100%;
    font-size: 16px;
    text-align: center;
    outline: none;
    border-radius: 10px;
    border: 1px solid #cccccc;
    font-family: TTNormsMedium, sans-serif;

  }
  .input::placeholder {
    color: #98a4ae;
    font-size: 14px;
    text-transform: capitalize;
    font-family: TTNormsLight, sans-serif;
  }
  .validate-error {
    bottom: -23px;
  }
  .toUppercase {
    text-transform: uppercase;
  }
  .btn {
    background-color: #6cc24a;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    cursor: pointer;
    outline: none;
    border: 1px solid transparent;
    height: 45px;
    border-radius: 25px;
    font-size: 18px;
    transition: all 0.5s linear;
    font-family: TTNormsMedium, sans-serif;
  }
  .btn.change {
    height: auto;
    width: auto;
    margin: 10px auto 0 auto;
    border-radius: 0px;
    padding: 0;
    color: #6cc24a;
    background-color: transparent;
  }
  .btn:disabled {
    cursor: default;
    background-color: rgba(108, 194, 74, 0.2);
    color: #6cc24a;
  }
  .btn:hover:enabled {
    background-color: transparent;
    color: #6cc24a;
    border: 1px solid #6cc24a;
  }
  .btn.change:hover:enabled {
    background-color: transparent;
    color: #6cc24a;
    border: 1px solid transparent;
  }
  .name {
    color: #005eb8;
    font-size: 24px;
    margin: 0 0 30px 0;
    text-align: center;
    font-family: TTNormsMedium, sans-serif;
  }
  .select {
    height: 45px;
    background-color: #fff;
    color: #98a4ae;
    text-align-last: center;
    padding:0px !important;
  }
  </style>
  